// Pure logic for the "example programmes" starter section.
//
// Kept out of the component so it can be tested without a DOM, matching
// programForm.js and authForm.js. The component owns the fetch, the navigation
// and the spinner; the wording lives here.

/**
 * The confirmation shown after a starter is copied.
 *
 * Says the same thing duplicate says — you now own an editable copy — because
 * that is exactly what happened: the example is untouched and this is yours.
 */
export function starterNotice(data) {
  const name = (data && data.name) ? data.name : 'the programme';
  return `Added "${name}" to your programmes. Open it to make it yours.`;
}

/** Whether the starters section has anything to show yet. */
export function hasStarters(examples) {
  return Array.isArray(examples) && examples.length > 0;
}
